import { intersection } from 'lodash';

import type { LocationCriteria } from './types';

export function getGeocodeRequest(
  criteria: LocationCriteria
): google.maps.GeocoderRequest {
  const geocodeRequest: google.maps.GeocoderRequest = {};

  if (criteria.position) {
    geocodeRequest.location = new google.maps.LatLng(
      criteria.position.latitude,
      criteria.position.longitude
    );
  }

  if (criteria.place) {
    geocodeRequest.placeId = criteria.place;
  }

  if (criteria.language) {
    geocodeRequest.language = criteria.language;
  }

  return geocodeRequest;
}

export function getComponentLongName(
  fromComponents: google.maps.GeocoderAddressComponent[],
  ofTypes: string[]
): string | undefined {
  const componentOfSpecifiedTypes = fromComponents.find((component) =>
    intersectionIsNotEmpty(component.types, ofTypes)
  );

  return componentOfSpecifiedTypes?.long_name;
}

function intersectionIsNotEmpty<T>(t1: T[], t2: T[]): boolean {
  return !!intersection(t1, t2).length;
}
